// Shared timezone list for Veyl.
//
// IMPORTANT: `value` is exactly what gets saved to Firestore ("GMT+3" etc.).
// It must never change, because the matching code and the midnight reset
// already depend on it. Only `places` is new — it is display-only, so users
// can recognise their timezone. Place names are proper nouns and are
// deliberately not translated.
//
// Places are listed by each zone's standard (non-daylight-saving) offset.
// Where a country shifts an hour in summer (e.g. London becomes GMT+1),
// the user simply picks whichever offset their clocks show right now.

export const TIMEZONES = [
  { value: 'GMT-12', places: 'Baker Island' },
  { value: 'GMT-11', places: 'American Samoa, Niue' },
  { value: 'GMT-10', places: 'Hawaii, Tahiti' },
  { value: 'GMT-9',  places: 'Alaska' },
  { value: 'GMT-8',  places: 'Los Angeles, Vancouver' },
  { value: 'GMT-7',  places: 'Denver, Phoenix, Calgary' },
  { value: 'GMT-6',  places: 'Chicago, Mexico City' },
  { value: 'GMT-5',  places: 'New York, Toronto, Bogotá, Lima' },
  { value: 'GMT-4',  places: 'Caracas, La Paz, Halifax' },
  { value: 'GMT-3',  places: 'São Paulo, Buenos Aires' },
  { value: 'GMT-2',  places: 'South Georgia, Fernando de Noronha' },
  { value: 'GMT-1',  places: 'Azores, Cape Verde' },
  { value: 'GMT+0',  places: 'London, Accra, Dakar, Lisbon' },
  { value: 'GMT+1',  places: 'Lagos, Algiers, Paris, Berlin' },
  { value: 'GMT+2',  places: 'Johannesburg, Cairo, Kigali, Harare' },
  { value: 'GMT+3',  places: 'Nairobi, Kampala, Addis Ababa, Moscow' },
  { value: 'GMT+4',  places: 'Dubai, Baku, Mauritius' },
  { value: 'GMT+5',  places: 'Karachi, Tashkent, Maldives' },
  { value: 'GMT+6',  places: 'Dhaka, Almaty' },
  { value: 'GMT+7',  places: 'Bangkok, Jakarta, Hanoi' },
  { value: 'GMT+8',  places: 'Singapore, Beijing, Manila, Perth' },
  { value: 'GMT+9',  places: 'Tokyo, Seoul' },
  { value: 'GMT+10', places: 'Sydney, Brisbane' },
  { value: 'GMT+11', places: 'Solomon Islands, Nouméa' },
  { value: 'GMT+12', places: 'Auckland, Fiji' },
];

// "GMT+3" -> "GMT+3 – Nairobi, Kampala, Addis Ababa, Moscow"
// Falls back to the raw value if it isn't in the list.
export function getTimezoneLabel(value) {
  const tz = TIMEZONES.find(z => z.value === value);
  return tz ? `${tz.value} – ${tz.places}` : value;
}